/**
 * Fixed bottom-right spinner shown during the per-campaign submit loop.
 * Parity: `ui-helpers.js:46-55` + `.submission-progress` CSS.
 *
 * During creatives upload the label includes file index + percent
 * (see ``formatCreativeUploadLabel``); optional ``percent`` draws a bar.
 */

export function SubmissionProgress({
  active,
  label,
  percent,
}: {
  active: boolean
  label: string
  /** 0–100 for the current file upload; omitted for queueing steps. */
  percent?: number | null
}) {
  if (!active) return null
  const showBar = typeof percent === "number" && percent >= 0
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-6 right-6 z-30 flex min-w-[14rem] flex-col gap-2 rounded-md border border-brand-border bg-brand-bg/90 px-4 py-3 text-sm shadow-lg backdrop-blur"
    >
      <div className="flex items-center gap-3">
        <span className="inline-block h-3 w-3 shrink-0 animate-spin rounded-full border-2 border-brand-accent border-t-transparent" />
        <span>{label}</span>
      </div>
      {showBar ? (
        <div
          className="h-1.5 w-full overflow-hidden rounded-full bg-brand-border/60"
          aria-hidden="true"
        >
          <div
            className="h-full rounded-full bg-brand-accent transition-[width] duration-150 ease-out"
            style={{ width: `${Math.min(100, Math.max(0, percent))}%` }}
          />
        </div>
      ) : null}
    </div>
  )
}
